import { getAccOrigin } from '@adsk/acs-sc-web-platform-api';

export const getProjectUrl = (projectId: string): string => {
  const projectUrl = `${getAccOrigin()}/build/rfis/projects/${projectId}`;
  return projectUrl;
};
